module.exports = __webpack_public_path__ + "img/icon-pdf.eb35c181.svg";